import React from "react";

const AkontacijaStrana = ({ podaci }) => {
  const {
    zavodniBroj = "",
    vozac = "",
    mesto = "",
    adresa = "",
    JMBG = "",
    brojPasosa = "",
    datumTransakcije = "",
    firma = "",
    mestoFirma = "",
    MB = "",
    PIB = "",
    iznos = "",
    brojPutnogNaloga = "",
    datumPolaskaPutniNalog = "",
  } = podaci ?? {};



  // const nbspIfEmpty = (v) =>
  //   v === 0 ? "0" : (v === null || v === undefined || v === "") ? "\u00A0" : v;

function pad2(n) { return String(n).padStart(2, "0"); }
function fmtDate(d) {
if (!d) return "";
const x = d instanceof Date ? d : new Date(d);
if (isNaN(x.getTime())) return String(d);
return `${pad2(x.getDate())}.${pad2(x.getMonth()+1)}.${x.getFullYear()}`;
}
function nbsp(v) { return (v === 0 ? "0" : (v == null || v === "") ? "\u00A0" : v); }


  return (
  <div className="print-page">
{/* Header */}
<div className="top-row">
  <div className="firma">
  {firma && <h2 className="naziv">{firma}</h2>}
  {mestoFirma && <h2 className="mesto">{mestoFirma}</h2>}
  </div>
</div>
<div className="broj">Broj: {nbsp(zavodniBroj || "______________")}</div>

<div className="titleBox">
    <h1 className="title">POTVRDA O ISPLATI NOVCA</h1>
</div>






{/* Glavni tekst 1 */}
<p className="paragraph">
Ja, {nbsp(vozac)}{mesto ? ` iz ${mesto}` : ""}{adresa ? `, ul. ${adresa}` : ""}
{JMBG ? ` JMBG: ${JMBG}` : ""}{brojPasosa ? ` broj pasoša: ${brojPasosa}` : ""} izjavljujem i svojim
svojeručnim potpisom potvrđujem, da sam dana {fmtDate(datumTransakcije)} godine, na ruke, od firme
{firma ? ` "${firma}"` : ""}{mestoFirma ? ` iz ${mestoFirma}` : ""}
{MB ? ` MB: ${MB}` : ""}{PIB ? ` , PIB: ${PIB}` : ""}, primio novac u iznosu od {nbsp(iznos)}: 
a na ime {brojPutnogNaloga != "" ? `AKONTACIJE ZA SLUŽBENO PUTOVANJE U ZEMLJI I INOSTRANSTVU, vezano za putni nalog ${brojPutnogNaloga} od ${fmtDate(datumPolaskaPutniNalog)}` : "ZAHTEVA ZA AKONTACIJU"}.
</p>


{/* Glavni tekst 2 */}
<p className="paragraph" style={{marginTop: '100px'}}>
Novac mi je predao ŠARČEVIĆ MIROSLAV iz Vrbasa JMBG: 0811991120007 u prisustvu svedoka ŠARČEVIĆ DARKA iz Vrbasa JMBG: 3008985120007,
a koji svojim svojeručnim potpisom isto i potvrđuju.
</p>

{/* Mesto i datum */}
<p className="meta">U Vrbasu, dana <span>{fmtDate(datumTransakcije)}</span></p>
{/* Potpisi */}
<div className="sign-row">
    <div className="sign-block">
        <div className="sign-title">NOVAC PREDAO</div>
        <div className="sign-line" />
        <div style={{marginTop:6}}>Šarčević Miroslav</div>
    </div>
     <div className="mp">m.p.</div>
    <div className="sign-block">
        <div className="sign-title">NOVAC PRIMIO</div>
        <div className="sign-line" />
        <div style={{marginTop:6}}>{nbsp(vozac)}</div>
    </div>
    <div className="sign-block">
      <div className="sign-title">SVEDOK</div>
      <div className="sign-line" />
      <div style={{marginTop:6}}>Šarčević Darko</div>
      
    </div>
    </div>
</div>
  );
};

export default AkontacijaStrana;
